import * as React from 'react';

function SvgProgressLost(props) {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.12 12a7.75 7.75 0 101.81-4.98.75.75 0 01-1.15-.97A9.25 9.25 0 113.61 12H2.5a.5.5 0 01-.42-.78L3.83 8.6a.5.5 0 01.83 0l1.78 2.62a.5.5 0 01-.42.78h-.9zm8.5-4.01v3.7l2.64 2.6a.75.75 0 01-1.05 1.07l-2.87-2.83a.75.75 0 01-.22-.53V7.99a.75.75 0 111.5 0z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgProgressLost;
